import { useEffect, useReducer } from 'react';

type State = {
  value: number;
  animate: boolean;
};

const INTERVAL = 1; // ms
const INCREMENT = 10;

export const useNumberAnimation = (total: number, animate: boolean) => {
  const reducer = (state: State) => {
    if (state.value < total && animate)
      return { value: state.value + INCREMENT, animate: true };
    else {
      return { value: total, animate: false };
    }
  };

  const [state, dispatch] = useReducer(reducer, { value: 0.1, animate: false });

  useEffect(() => {
    const interval = setInterval(dispatch, INTERVAL);
    return () => clearInterval(interval);
  }, []);

  return {
    ...state,
  };
};
